export default "__VITE_ASSET__LP_fs3O3__"